import TextWinds from '../../../components/common/TextWinds';
import { AgreementType } from '../../../components/common/Agreement';
import { AgreementBox } from '../../../components/common/AgreementBox';
import FormRow from '../../../components/common/input/FormRow';
import { Control, FieldErrors } from 'react-hook-form';
import { studentInfo } from './StudentFirstLogin';
import React from 'react';
import ErrorInput from '../components/ErrorInput';

export type ParentInfo = {
  name: string;
  birth: Date;
  gender: string;
  phone: string;
};

interface GuardianInputProps {
  control: Control<studentInfo>;
  errors: FieldErrors<studentInfo>;
  setAgree: (value: boolean) => void;
}
const GuardianInput = ({ control, errors, setAgree }: GuardianInputProps) => {
  const agreement = [
    { agree: AgreementType.PERSONAL_POLICY, essential: true },
    { agree: AgreementType.PERSONAL_COLLECTION, essential: true },
  ];

  return (
    <div className="flex flex-col gap-2">
      <TextWinds type={'title_h5'}>보호자 성함</TextWinds>
      <FormRow
        control={control}
        type="text"
        name="guardianInfo.name"
        placeholder="보호자 성함"
        rules={{
          required: '보호자 성함을 입력해주세요.',
          minLength: {
            value: 2,
            message: '2자 이상 입력해주세요.',
          },
          maxLength: {
            value: 20,
            message: '20자 이내로 입력해주세요.',
          },
          validate: (value) => {
            const pattern = /[^가-힣]/g;
            if (pattern.test(value)) {
              return '보호자 성함을 공백 제외 한글 2자 이상 20자 이내로 입력해주세요. ';
            }

            return true;
          },
        }}
      />
      <div className="min-h-2">
        {errors.guardianInfo && errors.guardianInfo.name && (
          <ErrorInput text={errors.guardianInfo.name.message} />
        )}
      </div>

      <TextWinds type={'title_h5'}>보호자 생년월일 및 성별</TextWinds>
      <div className="grid grid-cols-2 gap-2">
        <FormRow
          control={control}
          type="date"
          name="guardianInfo.birthday"
          placeholder="보호자 생년월일"
          rules={{
            required: '보호자 생년월일을 선택해주세요.',
          }}
        />
        <FormRow
          control={control}
          type="gender"
          name="guardianInfo.gender"
          placeholder="보호자 성별"
          rules={{
            required: '보호자 성별을 선택해주세요.',
          }}
        />
      </div>
      <div className="grid min-h-2 grid-cols-2 gap-2">
        <div>
          {errors.guardianInfo && errors.guardianInfo.birthday && (
            <ErrorInput text={errors.guardianInfo.birthday.message} />
          )}
        </div>
        <div>
          {errors.guardianInfo && errors.guardianInfo.gender && (
            <ErrorInput text={errors.guardianInfo.gender.message} />
          )}
        </div>
      </div>

      <section className="mt-3 flex flex-col gap-5">
        <div className="flex flex-col gap-2">
          <TextWinds type={'title_h5'}>보호자 연락처</TextWinds>
          <FormRow
            control={control}
            type="phone"
            name="guardianInfo.phone"
            placeholder="숫자만 입력해주세요."
            rules={{
              required: '보호자 연락처를 입력해주세요.',
              validate: (value) => {
                // 값이 비어있으면 통과
                if (!value) return true;

                // 숫자가 아닌 문자 제거
                const cleaned = value.replace(/\D/g, '');

                // 길이 체크 (10-11자리)
                if (cleaned.length < 10 || cleaned.length > 11) {
                  return '올바른 전화번호가 아닙니다';
                }

                // 패턴 체크 (010, 011 등으로 시작)
                const pattern = /^(01[016789])(\d{3,4})(\d{4})$/;
                if (!pattern.test(cleaned)) {
                  return '올바른 전화번호가 아닙니다';
                }

                return true;
              },
            }}
          />
          <div className="min-h-2">
            {errors.guardianInfo && errors.guardianInfo.phone && (
              <ErrorInput text={errors.guardianInfo.phone.message} />
            )}
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <AgreementBox agreementList={agreement} essentialChecked={setAgree} />
        </div>
      </section>
    </div>
  );
};

export default GuardianInput;
